import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';

import type { IHamburgerMenuContainerCarmiProps } from './HamburgerMenuContainer.mapper';
import { props as viewerPropsMapper } from './HamburgerMenuContainer.mapper';
import type { IHamburgerMenuContainerProps } from '../HamburgerMenuContainer.props';
import type { IHamburgerMenuContainerDefinition } from '../documentManagement/HamburgerMenuContainer.definition';

const props = composeMapper<
  IHamburgerMenuContainerProps,
  IHamburgerMenuContainerDefinition,
  IHamburgerMenuContainerCarmiProps
>()(
  viewerPropsMapper,
  { add: ['componentViewMode'] },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);
    const { componentViewMode } = dependencies;

    return {
      ...viewerProps,
      disableAnimations: componentViewMode === 'editor',
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
